module.exports = __webpack_public_path__ + "img/ico-no-profile.ac6513e2.svg";